<template>
  <a-select
      :options="displayRuleOptions"
      v-model.sync="localValue"
      :is-searchable="false"
      :has-teleport="!outsideModal"
      @blur="removeClass"
      @focus="addClass"
      @input="removeClass"
      @mouseenter="addClass"
      @mouseleave="removeClass"></a-select>
</template>

<script lang="ts">
  import Vue from "vue";
  import LocalValueEmissionMixin from "../../../mixins/localValueEmissionMixin";
  import {JoinType} from "../../../models/conditionalRules/joinType";

  export default Vue.extend({
    props: {
      value: {},
      outsideModal: {
        type: Boolean,
        default: false
      },
    },
    mixins: [LocalValueEmissionMixin],
    data() {
      return {
        displayRuleOptions: [
          {label: 'And', value: JoinType.and},
          {label: 'Or', value: JoinType.or}
        ]
      }
    },
    mounted(): void {
      if (this.value === null) {
        this.$emit('input', this.displayRuleOptions[0].value);
      }
    },
    computed: {
      hoverClass(): 'green' | 'blue' {
        return this.value === JoinType.and ? 'blue' : 'green';
      }
    },
    methods: {
      addClass(): void {
        this.getAllAndOrButtonsWithinGroup().addClass(this.hoverClass + ' hover');
      },
      removeClass(): void {
        this.getAllAndOrButtonsWithinGroup().removeClass('green blue hover');
      },
      getAllAndOrButtonsWithinGroup() {
        return $(this.$el).closest('.row').siblings().addBack().find('> .head button.btn-select');
      }
    }
  });
</script>